import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {AnonymousButtonsContainerBox} from "./boxes/buttons-container/anonymous-buttons-container.box";
import React from "react";
import {getButtonsSeparator} from "../header-welcome-buttons-helpers";
import {
    IGameContextViewModel
} from "../../../../services/game-runner/interfaces/game-context/game-context-view-model.interface";

interface HeaderWelcomeButtonsForAnonymousUserComponentProps {
    gameContext?: IGameContextViewModel;
}

export const HeaderWelcomeButtonsForAnonymousUserComponent = observer(
    class HeaderWelcomeButtonsForAnonymousUserComponent extends OrbitComponent<HeaderWelcomeButtonsForAnonymousUserComponentProps> {

        render() {
            const separator = getButtonsSeparator(this.services);
            return (
                <AnonymousButtonsContainerBox>
                    {separator}
                    {this.services.regulation.current.components.renderHeaderRegisterButton({gameContext: this.props.gameContext})}
                    {separator}
                    {this.services.regulation.current.components.renderHeaderLoginButton({gameContext: this.props.gameContext})}
                </AnonymousButtonsContainerBox>
            );
        }
    }
);